import { configureStore } from '@reduxjs/toolkit';
import projectReducer from '../component/project/redux/projectReducer';

const store = configureStore({
	reducer: projectReducer,
	// devTools enabled by default in development
});

export default store;